module.exports = __webpack_public_path__ + "static/img/xiandaifuwu-1.3d58cf99.svg";